<h3 [innerHTML]="this.data.window_title | safeHtml"></h3>
<div class="data-search-window">
  <div>
    <div class="top-row-controls-container">
      <div class="row" [hidden]="data.hide_search">
        <scaffold-search-bar
          [allowSearch]="true"
          (search)="search($event)"
          [searchData]="data.listSearchOptions || []"
          [(perPage)]="perPage"
        ></scaffold-search-bar>
      </div>

      <scaffold-paginate-page-select
        (perPageChange)="perPageChange($event)"
        [(perPage)]="perPage"
        [countLabel]="getCountLabel()"
      ></scaffold-paginate-page-select>
    </div>
  </div>
  <div
    *ngIf="results"
    class="data-search-results scaffold-list-holder"
    [ngClass]="{ 'horizontal-list': data.horizontal_list }"
  >
    <!-- <scaffold-paginator
      *ngIf="!data.hide_search"
      [itemCount]="listTotalNumberOfItems"
      [(activePage)]="active"
      [perPage]="perPage"
    ></scaffold-paginator> -->
    <div
      class="scaffold-list-item"
      *ngFor="let ite of results; let $i = index"
      [ngClass]="{
        'scaffold-item-selected': ite === selected,
        'scaffold-item-disabled': isLinked(ite.id) && !data.allow_multiple
      }"
    >
      <div (click)="setSelected(ite, $i)" class="flex-row flex-vertical-center">
        <div
          class="flex-column-0"
          style="padding: 0 5px"
          *ngIf="!data.horizontal_list && data.allow_multiple"
        >
          <nb-checkbox
            status="info"
            [(ngModel)]="data_check[ite.id].linked"
            style="pointer-events: none"
          >
          </nb-checkbox>
        </div>
        <div class="flex-column-1">
          <app-view
            [items]="ite.data.content"
            [info]="ite"
            [data]="{}"
          ></app-view>
          <div
            style="text-align: center; display: block; margin-bottom: 5px"
            *ngIf="data.horizontal_list"
          >
            <nb-checkbox
              status="info"
              [(ngModel)]="data_check[ite.id].linked"
              style="pointer-events: none"
              *ngIf="data.allow_multiple"
            >
            </nb-checkbox>
          </div>
        </div>
      </div>
      <hr *ngIf="!data.horizontal_list" />
    </div>
    <scaffold-paginator
      *ngIf="!data.hide_search"
      [itemCount]="listTotalNumberOfItems"
      [(activePage)]="active"
      [perPage]="perPage"
    ></scaffold-paginator>
  </div>
</div>
